module.exports = "https://portperrypedals.ca/_res/img/2022-start.705803f.jpg";